// extracted by mini-css-extract-plugin
module.exports = {"preserveOutline":"InboxButton_preserveOutline__3Z0H6","button":"InboxButton_button__2S4up InboxButton_preserveOutline__3Z0H6","svg":"InboxButton_svg__1vZIr"};